import removespace from '../../util/removeSpace';
import trim from '../../util/trim';
import gamename from '../../util/gameName';
import isMobile from '../../util/isMobile';
import trace from '../../trace/trace';

import facebook from './facebook';
import twitter from './twitter';
import kakaostory from './kakaostory';
import kakaotalk from './kakaotalk';
import googleplus from './googleplus';
import line from './line';
import copyurl from './copyurl';

let pageTitle = removespace(document.title).split(':plaync')[0];

const getShareBox = (list) =>{
    let button = '';
    for(let i = 0, max = list.length; i < max; i++) {
        button += `<a href="#none" class="share__button share__button--${list[i]}" data-share="${list[i]}">${list[i]} 공유하기</a>`;
    }
    return `<button class="share__toggle"></button><div class="share__list">${button}</div>`;
};

$('.share').each(function(){
    $(this).append(getShareBox(['facebook', 'twitter', 'googleplus', 'kakaotalk', 'line', 'url']));

    if(isMobile()) {
        $(this).addClass('share--mobile');
    }
});

const resetPosition = (shareArea) =>{
    let DOM_SHARE = shareArea;
    let DOM_SHARELIST = DOM_SHARE.find('.share__list');
    let listWidth = DOM_SHARELIST.width();
    let screenWidth = $(window).width();
    let buttonWidth = DOM_SHARE.find('.share__toggle').width();
    let offsetLeft = DOM_SHARE.offset().left;
    let offsetRight = offsetLeft + buttonWidth;

    let position = {left: `${(-listWidth / 2) + (buttonWidth / 2)}px`};

    if(offsetLeft + (buttonWidth / 2) < screenWidth / 2) {
        if((buttonWidth / 2 - 12) <= -offsetLeft + (screenWidth - listWidth) / 2) {
            position = {left: -offsetLeft};
        } else {
            position = {left: -offsetLeft + (screenWidth - listWidth) / 2};
        }
    }

    if(offsetLeft + (buttonWidth / 2) > screenWidth / 2) {
        if(buttonWidth / 2 - 12 <= -(screenWidth - offsetRight) + (screenWidth - listWidth) / 2) {
            position = {right: -(screenWidth - offsetRight)};
        } else {
            position = {right: -(screenWidth - offsetRight) + (screenWidth - listWidth) / 2};
        }
    }

    DOM_SHARELIST.css(position);
};

$(document).on(isMobile() ? 'touchstart.promo.share' : 'click.promo.share', (e) =>{
    if(/(share__button|share__list|share__toggle)/i.test(e.target.className)) return;

    $('.share__toggle').removeClass('share__toggle--active');
});

$(document).on('click.promo.share', '.share__toggle', function(e){
    e.preventDefault();
    if(!$(this).hasClass('share__toggle--active')) {
        $('.share__toggle').removeClass('share__toggle--active');
    }

    $(this).toggleClass('share__toggle--active');

    resetPosition($(this).closest('.share'));
});

$(document).on('click.promo.share', '[data-share]', function(e){
    e.preventDefault();

    let shareType = trim($(this).attr('data-share'));
    let shareUrl = $(this).attr('data-share-url');

    switch(shareType) {
        case 'facebook':
            facebook(shareUrl);
            break;
        case 'twitter':
            twitter(shareUrl);
            break;

        case 'kakaostory':
            kakaostory(shareUrl);
            break;

        case 'kakaotalk':
            kakaotalk(shareUrl);
            break;

        case 'googleplus':
            googleplus(shareUrl);
            break;

        case 'line':
            line(shareUrl);
            break;

        case 'url':
            copyurl(shareUrl);
            break;
    }

    trace(`/${gamename().ko}/이벤트프로모션/${pageTitle}/${shareType}`);
});

export default {
    facebook,
    twitter,
    kakaostory,
    kakaotalk,
    googleplus,
    line,
    copyurl
};